/**
 * Navigation Equipment Guidance - SIMPLIFIED DIRECT SYSTEM
 * Every requirement ID maps directly to guidance - NO MAPPINGS, NO COMPLEXITY
 * Based on Regulations Assistant verified guidance
 */

import { NAV_SIMPLE_GUIDANCE, getNAVSimpleGuidance } from './nav.simple.js';

/**
 * Simple Direct Navigation Guidance - NO MAPPINGS
 * @param {string} itemId - Equipment requirement ID
 * @returns {Object|null} Guidance object or null
 */
export function getNAVGuidance(itemId) {
  return getNAVSimpleGuidance(itemId);
}

// Export the guidance object for compatibility
export { NAV_SIMPLE_GUIDANCE as NAV_GUIDANCE };